module.exports = __webpack_public_path__ + "static/second-db4f790805a5fb0e781c9c468e728f60.png";